import BaseLink from 'next/link';
import { Router as BaseRouter, useRouter as useRouterHook } from 'next/router';

export interface BaseRouteParams {
  message?: string;
  messageType?: 'info' | 'success' | 'warning' | 'error';
}

export const Link = BaseLink;
export const Router = BaseRouter;
export const useRouter = useRouterHook;
// export const routes = BaseRoutes;
